import React, { useState, useEffect } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import ArrowWhite from "../../components/blueButton/Arrow.png";
import Img1 from "./img1.png";
import ResponsiveImg1 from "./newimg1.png";
import Img2 from "./Google.png";
import Img3 from "./Star.png";
import ClintImg1 from "./img01.png";
import ClintImg2 from "./img02.png";
import ClintImg3 from "./img03.png";
import ClintImg4 from "./img04.png";
import ClintImg5 from "./img05.png";
import ClintImg6 from "./img06.png";
import ClintImg7 from "./img07.png";
import ClintImg8 from "./img08.png";
import ClintImg9 from "./img09.png";
import ClintImg10 from "./img10.png";
import ClintImg11 from "./img11.png";
import ClintImg12 from "./img12.png";
import ClintImg13 from "./img13.png";
import ClintImg14 from "./img14.png";
// import ClintImg12 from "./img12.png";
// import ClintImg13 from "./img13.png";
import ValueImg1 from "./valueimg1.png";
import ValueImg2 from "./valueimg2.png";
import ValueImg3 from "./valueimg3.png";
import ValueImg4 from "./valueimg4.png";
import Blogimg1 from "./blogimg1.png";
import Blogimg2 from "./blogimg2.png";
import Blogimg3 from "./blogimg3.png";
import Arrow from "./arrow.png";
import Icon1 from "./Icon1.png";
import Icon2 from "./Icon2.png";
import Icon3 from "./Icon3.png";
import Icon4 from "./Icon4.png";
import Homeimg1 from "./homeimg1.png";
import Homeimg2 from "./homeimg2.png";
import Homeimg3 from "./homeimg3.png";
import Homeimg4 from "./homeimg4.png";
import Homeimg5 from "./homeimg5.png";
import Homeimg6 from "./homeimg6.png";
import Homeimg7 from "./homeimg7.png";
import Homeimg8 from "./homeimg8.png";
import Homeimg9 from "./homeimg9.png";
import Mdimage from "./mdimage.png";
import Heroimg from "./Hero.png";
import Bluebutton from "../../components/blueButton/Bluebutton";
import whiteArrow from "../../components/blueButton/Arrow.png";
import OurTeam from "../../components/ourTeam/OurTeam";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import axios from "axios";
import Testimonial from "../../components/testimonial/Testimonial";
import Container from "react-bootstrap/Container";
import LayoutOne from "../../components/Layout/LayoutOne";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
// import 'swiper/swiper-bundle.min.css';
// import 'swiper/swiper.min.css';
// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay, Navigation } from "swiper/modules";
import "./home.css";
const Home = ({ blogs }) => {
  // const [blog, setBlog] = useState(props.blogs);
  // const [formData, setFormData] = useState({
  //   name: "",
  //   phone_number: "",
  //   email: "",
  // });
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   console.log("formData", formData);
  // };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };
  const images = [
    ClintImg1,
    ClintImg2,
    ClintImg3,
    ClintImg4,
    ClintImg5,
    ClintImg6,
    ClintImg7,
  ];
  const images1 = [
    // ClintImg7,
    // ClintImg1,
    ClintImg8,
    ClintImg9,
    ClintImg10,
    ClintImg11,
    ClintImg12,
    ClintImg13,
    ClintImg14,
    // ClintImg2,
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;
    const newErrors = {
      name: "",
      email: "",
      phone: "",
    };

    // Validate Name
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
      valid = false;
    }

    // Validate Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    }

    // Validate Phone
    const phoneRegex = /^[0-9]{10}$/; // Example for 10-digit numbers
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
      valid = false;
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit phone number.";
      valid = false;
    }

    setErrors(newErrors);

    if (valid) {
      console.log("Form Data Submitted:", formData);
      window.alert("Form submitted successfully");
      setFormData({
        name: "",
        email: "",
        phone: "",
      });
    } else {
      console.error("Validation failed:", newErrors);
    }
  };
  const mdtexts = [
    {
      text: "Udaya Solution established in 2007, passion to match the right people to the right job has helped us to amass over a decade of successful stories in the human resource business.",
    },
    {
      text: "Each client and candidate is like an extended family member to us. And like family, we understand and anticipate your needs, matching the right candidates to the right clients.",
    },
    {
      text: "Our professionalism, coupled with a strong personal touch enhances the probability of success at every step. Our goal is to create a long-lasting client-candidate relationship, which will translate into long term winning strategies and exponential growth for both parties.",
    },
    {
      text: "At Udaya Solution, we understand that overall chemistry between the candidate and the existing management is paramount in ensuring a good match.",
    },
    {
      text: "To ensure success, we believe in hiring people with the right values and specialized experience. If you wish to find out more or engage our manpower solution, please do not hesitate to contact us. We look forward to serve you in our professional journey.",
    },
  ];
  return (
    <LayoutOne>
      <Navb />
      <div className="container">
        <div
          className="row align-items-end justify-content-center "
          style={{
            "background-color": "var(--primary-color)",
            "border-radius": "22px",
            // height: "90vh",
          }}
        >
          <div className="col-lg-6 col-md-10 col-sm-10 col-xs-10 width-45 px-0 py-10 fade-slide left">
            {/* <div className="row g-lg-1 g-md-4 g-sm-4 g-4 align-items-center justify-content-center flex-lg-row flex-md-column-reverse flex-sm-column-reverse flex-column-reverse">
              <div className="col-lg-7 col-md-10 col-sm-10 col-xs-10 fade-slide left"> */}
            <div className="homeTop d-flex align-items-lg-start align-items-md-center align-items-sm-center text-lg-start text-md-center text-sm-center">
              <div className="homeTopHeader">
                HR Consulting In
                <span className="homeTopHeaderBlue">The Digital Age</span>
              </div>
              <div className="homeTopP">
                Unleash individual potential and business excellence with our
                 cutting-edge HR consulting. Elevating careers and companies in
                the digital era. Welcome to a transformative future of growth
                and success.
              </div>

              <div className="homeTopP1">
                Unleash individual potential and business excellence with our
                &nbsp;
                <span className="block">cutting-edge</span> HR consulting.
              </div>
              {/* <Bluebutton Text="Get In Touch" Link="contact" /> */}
              <Link to="/contact" className="removeLinkDecoration">
                <button className="whitebutton">
                  Get In Touch <img src={ArrowWhite} alt="Arrow" />
                </button>
              </Link>
              <img
                src={Heroimg}
                alt="Heroimg"
                style={{ position: "absolute", width: "18rem", left: "-91px" }}
              />
              {/* <div className="homeTopRating">
                    <img src={Img2} alt="Img2" />
                    <span>&nbsp;&nbsp;4.1&nbsp;&nbsp;</span>
                    <img src={Img3} alt="Img3" />
                    <img src={Img3} alt="Img3" />
                    <img src={Img3} alt="Img3" />
                    <img src={Img3} alt="Img3" />
                    <img src={Img3} alt="Img3" />
                  </div> */}
            </div>
          </div>
          <div className="px-0 pt-4 width-45 col-lg-6 col-md-10 col-sm-10 col-xs-10 fade-slide right">
            <img className="homeTopImg" src={Img1} alt="Img1" />
            {/* <img
              className="res_homeTopImg"
              src={ResponsiveImg1}
              alt="ResponsiveImg1"
            /> */}
          </div>
        </div>
        {/* </div>
        </div> */}
      </div>
      <Container>
        <Swiper
          className="pt-5 pb-4"
          spaceBetween={50}
          loop={true} // Infinite loop
          autoplay={{
            delay: 3000, // Time between slides in ms (3000ms = 3 seconds)
            disableOnInteraction: false, // Continue autoplay even after user interacts
          }}
          modules={[Autoplay]} // Here we define the modules to be used (Autoplay in this case)
          // onSlideChange={() => console.log("slide change")}
          // onSwiper={(swiper) => console.log(swiper)}
          breakpoints={{
            // when window width is >= 1024px (desktop)
            1024: {
              slidesPerView: 6, // Show 6 slides
            },
            // when window width is >= 768px (tablet)
            768: {
              slidesPerView: 4, // Show 4 slides
            },
            // when window width is < 768px (mobile)
            480: {
              slidesPerView: 2, // Show 2 slides
            },
            // when window width is < 480px (smaller mobile)
            0: {
              slidesPerView: 1, // Show 1 slide on very small screens
            },
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%", // Ensure image takes full width of slide
                  height: "auto",
                  borderRadius: "10px", // Optional: Rounded corners
                  objectFit: "cover",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <Swiper
          className="pt-4 pb-5"
          spaceBetween={50}
          loop={true} // Infinite loop
          autoplay={{
            delay: 3000, // Time between slides in ms (3000ms = 3 seconds)
            disableOnInteraction: false, // Continue autoplay even after user interacts
          }}
          modules={[Autoplay]} // Here we define the modules to be used (Autoplay in this case)
          // onSlideChange={() => console.log("slide change")}
          // onSwiper={(swiper) => console.log(swiper)}
          breakpoints={{
            // when window width is >= 1024px (desktop)
            1024: {
              slidesPerView: 6, // Show 6 slides
            },
            // when window width is >= 768px (tablet)
            768: {
              slidesPerView: 4, // Show 4 slides
            },
            // when window width is < 768px (mobile)
            480: {
              slidesPerView: 2, // Show 2 slides
            },
            // when window width is < 480px (smaller mobile)
            0: {
              slidesPerView: 1, // Show 1 slide on very small screens
            },
          }}
        >
          {images1.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%", // Ensure image takes full width of slide
                  height: "auto",
                  borderRadius: "10px", // Optional: Rounded corners
                  objectFit: "cover",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
      {/* <Container>
        <div className="row ">
          <div className="col-lg-2 col-md-4 col-sm-4 col-6  d-flex justify-content-center">
            <img src={ClintImg4} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg5} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg6} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg7} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg8} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg9} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg10} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg11} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg12} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg13} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg1} alt="ClintImg" />
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex justify-content-center">
            <img src={ClintImg2} alt="ClintImg" />
          </div>
        </div>
      </Container> */}
      {/* <div className="homeServices">Explore Our Services</div> */}
      {/* <div className="homeServicesText">
        Strategic HR Innovations: Elevate Your Workplace Dynamics
      </div> */}

      <Container
        className="aboutHeader row p-0 align-items-center justify-content-center "
        style={{ margin: "2rem auto" }}
      >
        <div
          className="aboutimgHeader col-lg-6 col-md-10 col-sm-12"
          // style={{ overflow: "hidden", borderRadius: "18px" }}
        >
          <div className="d-flex gap-3">
            <div className="flex-grow-1 d-flex align-items-center flex-column gap-3">
              <img src={Homeimg1} alt="Homeimg1" style={{ width: "100%" }} />
              <img src={Homeimg3} alt="Homeimg3" style={{ width: "80%" }} />
            </div>
            <div className="flex-grow-1 d-flex flex-column align-items-center gap-3">
              <div
                className="d-flex align-items-center justify-content-center gap-3"
                style={{
                  border: "2px solid var(--primary-color)",
                  padding: "42px 12px",
                  borderRadius: "20px",
                  backgroundColor: "var(--primary-color)",
                }}
              >
                <span
                  className="Heading43 text-white"
                  style={{ fontSize: "58px" }}
                >
                  14
                </span>
                <span
                  className="fs-5 fw-6 text-white"
                  style={{ fontWeight: "600", width: "45%" }}
                >
                  Years Of Experience
                </span>
              </div>
              <img src={Homeimg2} alt="Homeimg2" style={{ width: "100%" }} />
            </div>
          </div>
        </div>

        <div className="aboutHeaderText1 col-lg-6 col-md-10 col-sm-12 text-center text-lg-start ps-4">
          <div className="d-flex gap-3 pb-2">
            <img src={Homeimg4} alt="Homeimg4" />{" "}
            <span
              style={{ "font-weight": "600", color: "var(--primary-color)" }}
            >
              Why Choose Us
            </span>
          </div>
          <div
            className="Heading43 mt-5 mt-lg-0 mb-4"
            // style={{"line-height": "50px"}}
          >
            Where Wanderlust Meets{" "}
            <span style={{ color: "var(--primary-color)" }}>
              Dream Destinations
            </span>
          </div>
          <p>
            Et purus duis sollicitudin dignissim habitant. Egestas nulla quis
            venenatis cras sed eu massa Et purus duis sollicitudin dignissim
            habitant. Egestas nulla quis venenatis cras sed eu massa Et purus
            duis sollicitudin dignissim habitant. Egestas nulla sollicitudin
            dignissim habitant. Egestas nulla sollicitudin dignissim habitant.
            Egestas nulla sollicitudin dignissim habitant. Egestas nulla
          </p>
          <div className="d-flex flex-wrap gap-3 pb-3 pt-2">
            <div
              className="d-flex flex-column gap-3"
              style={{
                border: "1px solid var(--primary-color)",
                padding: "22px",
                "border-radius": "16px",
              }}
            >
              <div className="d-flex justify-content-center align-items-center gap-3">
                <div
                  style={{
                    "background-color": "var(--primary-color)",
                    padding: "8px",
                    "border-radius": "24px",
                  }}
                >
                  <img src={Homeimg6} alt="Homeimg6" />
                </div>
                <div>Project Done</div>
              </div>
              <div
                className="d-flex  align-items-center gap-2"
                style={{ "font-size": "14px" }}
              >
                <img src={Homeimg5} alt="Homeimg5" />
                <div>600 Projects Done</div>
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{ "font-size": "14px" }}
              >
                <img src={Homeimg5} alt="Homeimg5" />
                <div>2000+ Recruitments Done</div>
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{ "font-size": "14px" }}
              >
                <img src={Homeimg5} alt="Homeimg5" />
                <div>150+ clients</div>
              </div>
            </div>
            <div
              className="d-flex flex-column gap-3"
              style={{
                border: "1px solid var(--primary-color)",
                padding: "22px",
                "border-radius": "16px",
              }}
            >
              <div className="d-flex justify-content-center align-items-center gap-3">
                <div
                  style={{
                    "background-color": "var(--primary-color)",
                    padding: "8px",
                    "border-radius": "24px",
                  }}
                >
                  <img src={Homeimg9} alt="Homeimg6" />
                </div>
                <div>National Entry</div>
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{ "font-size": "14px" }}
              >
                <img src={Homeimg5} alt="Homeimg5" />
                <div>No. 1 HR Consultancy North</div>
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{ "font-size": "14px" }}
              >
                <img src={Homeimg5} alt="Homeimg5" />
                <div>4500+ position</div>
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{ "font-size": "14px" }}
              >
                <img src={Homeimg5} alt="Homeimg5" />
                <div>21 + Sectors</div>
              </div>
            </div>
          </div>
          <Link to="/contact" className="removeLinkDecoration">
            <button className="whitebutton" href="/contact">
              Read More <img src={ArrowWhite} alt="Arrow" />
            </button>
          </Link>
          {/* <Bluebutton Text="Read More" Link="contact" /> */}
        </div>
      </Container>

      {/* <div className="container">
        <div className="row g-lg-2 g-md-4 g-sm-4 g-4 justify-content-center mb-5">
          <div className="col-lg-3 col-md-6 col-sm-10 col-10 d-flex justify-content-center">
            <OurTeam
              Icon={Icon2}
              Heading="Management Consulting"
              Text="Our team comprises qualified professionals who have strong rapport
            with Udaya Solution and have experience in multiple disciplines
            including Human Resources, Technology, Sales and Marketing."
              href="/Management_Consulting"
              link="link"
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-10 col-10  d-flex justify-content-center">
            <OurTeam
              Icon={Icon3}
              Heading="Vendor On Premise"
              Text="Our experienced team delivers tailored Vendor On Premise (VOP) solutions, ensuring seamless integration and management of vendor resources directly on-site to enhance operational efficiency and support business growth."
              href="/Vendor_On_Premise"
              link="link"
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-10 col-10  d-flex justify-content-center">
            <OurTeam
              Icon={Icon1}
              Heading="Staffing / Recruitment"
              Text="Our team comprises qualified professionals who have strong rapport
            with Udaya Solution and have experience in multiple disciplines
            including Human Resources, Technology, Sales and Marketing."
              href="/Staffing_Recruitment"
              link="link"
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-10 col-10  d-flex justify-content-center">
            <OurTeam
              Icon={Icon3}
              Heading="IT Infrastructure and Support"
              Text="Our dedicated team provides comprehensive IT infrastructure solutions, offering expertise in network management, server maintenance, and security to ensure seamless technology operations and business continuity."
              href="/IT_Infrastructure"
              link="link"
            />
          </div>
        </div>
      </div> */}
      <Container className="mt-5">
        <div className="services-container">
          <div style={{ margin: "1px auto", width: "80%" }}>
            {/* Header Section */}
            <div className="services-header mb-5" style={{ color: "black" }}>
              <div className="d-flex gap-3 mb-2">
                <img src={Homeimg8} alt="Homeimg8" />{" "}
                <span
                  style={{
                    "font-weight": "600",
                    // color: "white",
                  }}
                >
                  Our Services
                </span>
              </div>
              {/* <p className="mb-2 text-uppercase fw-semibold">Our Services</p> */}
              <h2>Explore our services</h2>
              <p>Strategic HR Innovations: Elevate Your Workplace Dynamics</p>
            </div>

            {/* Cards Section */}
            <div className="row justify-content-center g-4">
              <div className="col-12 col-md-6 col-lg-3 d-flex justify-content-center">
                <div className="service-card">
                  <img src={Icon1} alt="Management Consultant Icon" />
                  <h5>Management Consultant</h5>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 d-flex justify-content-center">
                <div className="service-card">
                  <img src={Icon2} alt="RPO Solutions Icon" />
                  <h5>RPO Solutions</h5>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 d-flex justify-content-center">
                <div className="service-card">
                  <img src={Icon3} alt="Payroll and Compliance Icon" />
                  <h5>Payroll & Compliance</h5>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 d-flex justify-content-center">
                <div className="service-card">
                  <img src={Icon4} alt="Staffing Icon" />
                  <h5>Staffing</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Container className="my-5" style={{ width: "70%" }}>
        <div className="row justify-content-center gap-3">
          <div className="col-10 col-md-6 col-lg-5 d-flex  justify-content-end justify-lg-center">
            <img
              src={Mdimage}
              alt="Mdimage"
              className="w-80"
              //  style={{ width: "80%" }}
            />
          </div>
          <div
            className="col-10 col-md-6 col-lg-5 p-4 d-flex flex-column gap-1 justify-content-center "
            style={{
              "background-color": "var(--primary-color)",
              color: "white",
              "border-radius": "11px",
            }}
          >
            <span style={{ "font-size": "4rem", "line-height": "15px" }}>
              "
            </span>
            {/* We have been operating for over an providin top-notch services to
            our clients and build strong track record in the industry.We have
            been operating for over a decad providi ina top-notch We have been
            operating */}
            <Swiper
              className="pt-2 pb-2"
              style={{ width: "-webkit-fill-available" }}
              spaceBetween={50}
              loop={true} // Infinite loop
              autoplay={{
                delay: 3000, // Time between slides in ms (3000ms = 3 seconds)
                disableOnInteraction: false, // Continue autoplay even after user interacts
              }}
              modules={[Autoplay]} // Here we define the modules to be used (Autoplay in this case)
              // onSlideChange={() => console.log("slide change")}
              // onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                // when window width is >= 1024px (desktop)
                1024: {
                  slidesPerView: 1, // Show 6 slides
                },
                // when window width is >= 768px (tablet)
                768: {
                  slidesPerView: 1, // Show 4 slides
                },
                // when window width is < 768px (mobile)
                480: {
                  slidesPerView: 1, // Show 2 slides
                },
                // when window width is < 480px (smaller mobile)
                0: {
                  slidesPerView: 1, // Show 1 slide on very small screens
                },
              }}
            >
              {mdtexts.map((mdtext, index) => (
                <SwiperSlide key={index}>
                  <span>{mdtext.text}</span>
                  {/* <img
                src={image}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%", // Ensure image takes full width of slide
                  height: "auto",
                  borderRadius: "10px", // Optional: Rounded corners
                  objectFit: "cover",
                }}
              /> */}
                </SwiperSlide>
              ))}
            </Swiper>
            <span className="pt-3">
              BISWA RANJAN DAS <br /> Managing Director
            </span>
          </div>
        </div>
      </Container>
      {/* <Container className="Testimonial">
        <Testimonial />
      </Container> */}
      {/* <Container className="homeValues">
        <div className="homeValue">
          <img src={ValueImg1} alt="ValueImg1" />
          <div className="homeValueText">
            <div className="homeValueTextTop">150+</div>
            <div className="homeValueTextBot">Clients</div>
          </div>
        </div>
        <div className="homeValue">
          <img src={ValueImg2} alt="ValueImg2" />
          <div className="homeValueText">
            <div className="homeValueTextTop">21+</div>
            <div className="homeValueTextBot">Sectors</div>
          </div>
        </div>
        <div className="homeValue">
          <img src={ValueImg3} alt="ValueImg3" />
          <div className="homeValueText">
            <div className="homeValueTextTop">4500+</div>
            <div className="homeValueTextBot">Positions</div>
          </div>
        </div>
        <div className="homeValue">
          <img src={ValueImg4} alt="ValueImg4" />
          <div className="homeValueText">
            <div className="homeValueTextTop">14+</div>
            <div className="homeValueTextBot">Years of Exp</div>
          </div>
        </div>
      </Container> */}
      {/* <div className="homeTouch">Let’s Get In Touch</div> */}
      <Container>
        <div className="d-flex gap-3 pb-2">
          <img src={Homeimg4} alt="Homeimg4" />{" "}
          <span style={{ "font-weight": "600", color: "var(--primary-color)" }}>
            Recent Blogs
          </span>
        </div>
        <div
          className="Heading43 mt-2 mt-lg-0 "
          style={{ "line-height": "55px", "margin-bottom": "-4rem" }}
        >
          Journeys of Discovery <br />
          Uncovering Hidden
        </div>

        <Swiper
          spaceBetween={50}
          loop={true} // Infinite loop
          autoplay={{
            delay: 3000, // 3 seconds between slides
            disableOnInteraction: false, // Continue autoplay after interaction
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }} // Enable navigation buttons
          modules={[Autoplay, Navigation]} // Use Autoplay and Navigation modules
          // onSlideChange={() => console.log("Slide changed")}
          // onSwiper={(swiper) => console.log("Swiper initialized:", swiper)}
          breakpoints={{
            // Desktop
            1024: {
              slidesPerView: 3, // Show 3 slides
            },
            // Tablet
            768: {
              slidesPerView: 2, // Show 2 slides
            },
            // Mobile
            480: {
              slidesPerView: 1, // Show 1 slide
            },
            // Extra small screens
            0: {
              slidesPerView: 1,
            },
          }}
        >
          <div className="swiper-button-prev">
            <img src={whiteArrow} alt="Previous" className="prev-arrow" />
          </div>
          <div className="swiper-button-next">
            <img src={whiteArrow} alt="Next" />
          </div>
          {blogs.map((blog, index) => (
            <SwiperSlide key={index}>
              <div className="blog-card">
                <div className="blog-image-placeholder">
                  <img src={blog.img} alt="Blogimg1" />
                  {/* <img src={Blogimg1} alt="Blogimg1" /> */}
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span>{blog.date}</span> <span>By {blog.author}</span>
                  </div>
                  <h4 className="blog-title">{blog.title}</h4>
                  <p className="blog-description">
                    {blog.description.length > 85
                      ? `${blog.description.substring(0, 85)}...`
                      : blog.description}
                  </p>
                  <Link to={`/blog/${index}`} className="read-more">
                    Read More →
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
      <Container
        className="mb-5 contactDesign"
        style={{
          // "background-color": "var(--primary-color)",
          "border-radius": "1rem",
          padding: "2rem 6rem",
        }}
      >
        <div className="d-flex gap-3 pb-2">
          <img src={Homeimg7} alt="Homeimg4" />{" "}
          <span style={{ "font-weight": "600", color: "white" }}>
            Our Coaching
          </span>
        </div>
        <div
          className="Heading43 mt-2 mt-lg-0 pb-2"
          style={{ "line-height": "55px", color: "white" }}
        >
          Lets Get In Touch
        </div>
        <form
          onSubmit={handleSubmit}
          className="needs-validation"
          noValidate
          style={{ width: "60%" }}
        >
          {/* Name */}
          <div className="form-floating mb-4">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              placeholder="Enter your name"
            />
            <label htmlFor="name">Name</label>
            <div className="invalid-feedback">{errors.name}</div>
          </div>

          {/* Email */}
          <div className="form-floating mb-4">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="Enter your email"
            />
            <label htmlFor="email">Email</label>
            <div className="invalid-feedback">{errors.email}</div>
          </div>

          {/* Phone */}
          <div className="form-floating mb-4">
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={`form-control ${errors.phone ? "is-invalid" : ""}`}
              placeholder="Enter your phone number"
            />
            <label htmlFor="phone">Phone</label>
            <div className="invalid-feedback">{errors.phone}</div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="btn btn-dark "
            style={{ width: "max-content" }}
          >
            Submit
          </button>
        </form>
      </Container>
      {/* <Container>

        <Form action="https://formspree.io/f/xbljrkyq" method="POST">
          <div className="homeallField">
            <InputGroup className="mb-3">
              <Form.Control
                className="homefield"
                placeholder="Name"
                aria-label="name"
                aria-describedby="basic-addon1"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <Form.Control
                className="homefield"
                placeholder="Phone_number"
                aria-label="phone_number"
                aria-describedby="basic-addon1"
                type="number"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
              <Form.Control
                className="homefield"
                placeholder="Email"
                aria-label="email"
                aria-describedby="basic-addon1"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <button className="homesubmitButton" type="submit">
                Request a CallBack
              </button>
            </InputGroup>
          </div>
        </Form>
      </Container> */}
      {/* <div className="graybg">
        <Container>
          <div className="homeBlog">Our Blogs</div>

          <div className="homeBlogSection ">
            <div className="homeBlogImg ">
              <img src={Blogimg1} alt="Blogimg1" />
              <div className="homeBlogText">
                <div className="homeBlogTextHeading">Realtime analytics</div>
                <div className="homeBlogTextP">
                  “The results have been incredible. With Power Digital, it
                  feels like they’re in our trench, supporting and understanding
                  us. They’re like a partner and mentor in helping us get where
                  we want to be. “The results have been incredible.
                </div>
                <div className="arrow">
                  <img src={Arrow} alt="Arrow" />
                </div>
              </div>
            </div>
            <div className="homeBlogImg ">
              <img src={Blogimg2} alt="Blogimg2" />
              <div className="homeBlogText">
                <div className="homeBlogTextHeading">Realtime analytics</div>
                <div className="homeBlogTextP">
                  “The results have been incredible. With Power Digital, it
                  feels like they’re in our trench, supporting and understanding
                  us. They’re like a partner and mentor in helping us get where
                  we want to be. “The results have been incredible.
                </div>
                <div className="arrow">
                  <img src={Arrow} alt="Arrow" />
                </div>
              </div>
            </div>
            <div className="homeBlogImg ">
              <img src={Blogimg3} alt="Blogimg3" />
              <div className="homeBlogText">
                <div className="homeBlogTextHeading">Realtime analytics</div>
                <div className="homeBlogTextP">
                  “The results have been incredible. With Power Digital, it
                  feels like they’re in our trench, supporting and understanding
                  us. They’re like a partner and mentor in helping us get where
                  we want to be. “The results have been incredible.
                </div>
                <div className="arrow">
                  <img src={Arrow} alt="Arrow" />
                </div>
              </div>
            </div>
            {blog && (
              <>
                <div className="homeBlogImg">
                  <img src={Blogimg1} alt="Blogimg1" />
                  <div className="homeBlogText">
                    <div className="homeBlogTextHeading">
                      Realtime analytics
                    </div>
                    <div className="homeBlogTextP">
                      “The results have been incredible. With Power Digital, it
                      feels like they’re in our trench, supporting and
                      understanding us. They’re like a partner and mentor in
                      helping us get where we want to be. “The results have been
                      incredible.
                    </div>
                    <div className="arrow">
                      <img src={Arrow} alt="Arrow" />
                    </div>
                  </div>
                </div>
                <div className="homeBlogImg">
                  <img src={Blogimg2} alt="Blogimg2" />
                  <div className="homeBlogText">
                    <div className="homeBlogTextHeading">
                      Realtime analytics
                    </div>
                    <div className="homeBlogTextP">
                      “The results have been incredible. With Power Digital, it
                      feels like they’re in our trench, supporting and
                      understanding us. They’re like a partner and mentor in
                      helping us get where we want to be. “The results have been
                      incredible.
                    </div>
                    <div className="arrow">
                      <img src={Arrow} alt="Arrow" />
                    </div>
                  </div>
                </div>
                <div className="homeBlogImg">
                  <img src={Blogimg3} alt="Blogimg3" />
                  <div className="homeBlogText">
                    <div className="homeBlogTextHeading">
                      Realtime analytics
                    </div>
                    <div className="homeBlogTextP">
                      “The results have been incredible. With Power Digital, it
                      feels like they’re in our trench, supporting and
                      understanding us. They’re like a partner and mentor in
                      helping us get where we want to be. “The results have been
                      incredible.
                    </div>
                    <div className="arrow">
                      <img src={Arrow} alt="Arrow" />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="centerButton"
            style={{ padding: "1rem 0rem 3rem 0rem", margin: "0rem" }}
          >
            {!blog && (
              <button
                className="bluebutton"
                onClick={() => {
                  setBlog(true);
                }}
                style={{ margin: "0px 0px" }}
              >
                View all posts
              </button>
            )}
            {blog && (
              <button
                className="bluebutton"
                onClick={() => {
                  setBlog(false);
                }}
                style={{ margin: "0px 0px" }}
              >
                View less posts
              </button>
            )}
          </div>
        </Container>
      </div> */}
      <Footer />
    </LayoutOne>
  );
};

export default Home;
